// extracted by mini-css-extract-plugin
export default {"root":"ShortcutsDrawer_root__iz0ZK","close":"ShortcutsDrawer_close__OLQMS","shortcuts":"ShortcutsDrawer_shortcuts__ZDd5x"};